import { ToolkitPropertyEnum, makeLookup } from '@aloft/toolkit-shared';

import { PropertyPinStatus } from '../components/Tkv2Map/types.ts';

export const getPropertyPinStatus = makeLookup<
  ToolkitPropertyEnum<'ListingStatusType'> | 'Subject',
  PropertyPinStatus
>({
  cases: [
    [['Active', 'ComingSoon'], 'Active'],
    [['Contract', 'Backup', 'Pending'], 'Pending'],
    ['SettledSale', 'Sold'],
    ['Rented', 'Rented'],
    [['Deleted', 'Cancelled', 'Expired', 'Off-Market', 'Withdrawn'], 'Off-Market'],
    [['Other', 'Unknown'], 'other'],
    ['Subject', 'Subject'],
  ],
  default: 'Off-Market',
});
